export function formatMoney(n) {
  const p = Math.round(Number(n || 0) * 100);
  const neg = p < 0 ? '-' : '';
  const a = Math.abs(p);
  const cents = (a % 100).toString().padStart(2, '0');
  const dollars = Math.floor(a / 100).toLocaleString();
  return `${neg}$${dollars}.${cents}`;
}

export function formatDate(d) {
  if (!d) return '';
  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-AU', { year: 'numeric', month: '2-digit', day: '2-digit' });
}

export function formatBytes(n) {
  if (!n) return '0 B';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
